import React from "react";
import {Box} from "./Box"
import "./Board.css"

export const Board = ({board, onClick, x, y, z}) => {
    return (
        <div className="board">
            {board.map((value,idx) => {
                if(x === -1) {
                    return <Box value={value} onClick={() => value === null && onClick(idx)} win={null}/>
                }
                else {
                    if(idx === x || idx === y || idx === z) {
                        return <Box value={value} onClick={() => value === null && onClick(idx)} win={'yes'}/>
                    }
                    else {
                        return <Box value={value} onClick={() => value === null && onClick(idx)} win={null}/>
                    }
                }
            })}
        </div>
    )
}